import React from "react";

const ButtonTransitionIntoCalc = ( {data} ) => {
    return(
        <button className="flex flex-shrink-0 red-custom-button rounded-full justify-between items-center 
                md:px-8 px-6 md:py-4 py-3 md:gap-2 gap-2 h-fit md:max-w-full md:w-[335px] max-w-[280px]"
                onClick={() => window.location.replace(data.button_transition_into_calculator.url_source)}
            >
            <span className="md:text-[20px] text-[18px] font-medium text-nowrap leading-tight" 
                    style={{color:data.button_transition_into_calculator.text_color}}
                >
                {data.button_transition_into_calculator.text}
            </span>
            <img src={data.button_transition_into_calculator.arrow} alt=""/>
        </button>
    );
};
export default ButtonTransitionIntoCalc;